/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Returns data from an object by reducing it with a filters map
 * @param data
 * @param filter
 * @returns
 */
export const processData = (data: object, filter: string) => {
  const selectors = filter.split('.')
  return selectors.reduce(
    (currSource: any, selector: string) => currSource?.[selector],
    data
  )
}
